import { render, staticRenderFns } from "./Categoria.vue?vue&type=template&id=125213e3&"
import script from "./Categoria.vue?vue&type=script&lang=js&"
export * from "./Categoria.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QPage,QToolbar,QBreadcrumbs,QBreadcrumbsEl,QSpace,QBtn,QTable,QTd,QChip,QIcon} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QPage,QToolbar,QBreadcrumbs,QBreadcrumbsEl,QSpace,QBtn,QTable,QTd,QChip,QIcon})
